import { useState, useEffect } from "react";
import Properties from "./Properties";
import PropertiesCab from "./PropertiesCab";
import { useDispatch, useSelector } from "../../../../redux/store";
import { CircularProgress } from "@mui/material";

const WishlistTable = ({
  tabItems,
  additionalData,
  setDirectList,
  setLoading,
  loading,
  dataOne,
  setDataOne,
  setActiveTab,
  activeTab,
  setBookingDetails,
  bookingData,
  setBookingData,
  setIsApiCall,
  selectedIndex,
  setSelectedIndex,
  setSubActiveTab,
  subActiveTab,
  cabs,
  rating,
  setRating,
  mainActiveTab,
}) => {
  const dispatch = useDispatch();
  const [datas, setDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const {
    listBookingSuccessRes,
  } = useSelector((state) => state.product);

  // When listBookingSuccessRes or sub-tab changes (Upcoming/History)
  useEffect(() => {
    setBookingData([]);
    setDatas([]);

    if (listBookingSuccessRes !== null) {
      let filteredData = [];
      if (subActiveTab === 0) {
        // Upcoming
        filteredData = listBookingSuccessRes?.upcoming?.filter(
          (item) => item.type === dataOne?.type
        ) || [];
      } else if (subActiveTab === 1) {
        // History
        filteredData = listBookingSuccessRes?.history?.filter(
          (item) => item.type === dataOne?.type
        ) || [];
      }

      setDatas(filteredData);
      setBookingData(filteredData);
      setLoading(false);
      setIsApiCall(false);
    }
  }, [subActiveTab, listBookingSuccessRes, dataOne?.type, setBookingData, setIsApiCall, setLoading]);

  // Cabs list (tab index 3)
  useEffect(() => {
    setBookingData([]);
    setDatas([]);

    if (subActiveTab === 0) {
      setDatas(cabs?.upcoming || []);
      setBookingData(cabs?.upcoming || []);
    } else if (subActiveTab === 1) {
      setDatas(cabs?.history || []);
      setBookingData(cabs?.history || []);
    }
    setLoading(false);
  }, [activeTab, cabs, subActiveTab, setBookingData, setLoading]);

  const handleViewDetails = (index, item) => {
    setBookingDetails(true);
    setSelectedIndex(index);
  };

  return (
    <>
      <div className="tabs__content pt-10 js-tabs-content">
        <div className="tabs__pane -tab-item-1 is-tab-el-active">
          <div className="row y-gap-20">
            {loading ? (
              <div style={{ textAlign: "center", width: "100%" }}>
                <CircularProgress
                  size="3rem"
                  sx={{ color: "black" }}
                />
              </div>
            ) : cabs && mainActiveTab === 3 ? (
              <PropertiesCab
                handleViewDetails={handleViewDetails}
                activeTab={subActiveTab}
                bookingData={cabs}
                currentPage={currentPage}
                dataOne={dataOne}
                loading={loading}
                setLoading={setLoading}
                setRating={setRating}
                rating={rating}
              />
            ) : (
              <Properties
                handleViewDetails={handleViewDetails}
                activeTab={activeTab}
                bookingData={bookingData}
                currentPage={currentPage}
                dataOne={dataOne}
                loading={loading}
                setLoading={setLoading}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WishlistTable;
